import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import { createAssignRefill, getAllRefill, createQuestion, getBnbList,
  getAllCleaner, uploadFile } from '../../helper/backend_helper';

const AddAssignRefill = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [refillItem, setRefillItem] = useState([]);
  const [bnb, setBnB] = useState([]);
  const [cleaner, setCleaner] = useState([]);
  const [refill, setRefill] = useState([]);

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  const [cleaners, setCleaners] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      // setUsers(usersResponse?.data?.data);
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function fetchCleaners() {
    try {
      const cleanerResponse = await getAllCleaner();
      setCleaners(
        cleanerResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || '';
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB);
        }) || []
      );
    } catch (error) {
      console.error('Error fetching cleaners:', error);
    }
  }

  async function fetchRefill() {
    try {
      const usersResponse = await getAllRefill();
      // setRefill(usersResponse?.data?.data);
      setRefill(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchRefill();
    fetchCleaners();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (bnb.length === 0 && cleaner.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Select at least one BnB or cleaner',
        });
        setLoading(false);
        return;
      }
      if (refillItem.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Select at least one refill item',
        });
        setLoading(false);
        return;
      }

      const Categorydata = {
        bnb,
        cleaner,
        refillItem,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createAssignRefill(Categorydata, Categoryheaders);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'created successfully',
      });
      setRefillItem([]);
      setBnB([]);
      setCleaner([]);

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Add Assign Refill </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Assign Refill</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Properties that should be stocked with the chosen refill items. Leave empty to assign by cleaner instead." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 3 }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Cleaner <InfoTooltip title="Cleaners responsible for restocking these refill items. Select at least one BnB or one cleaner." /></FormLabel>
              <Select
                labelId="cleaner-multi-select-label"
                id="cleaner-multi-select"
                multiple
                value={cleaner}
                onChange={(e) => setCleaner(e.target.value)}
                renderValue={(selected) =>
                  selected
                    .map((id) => cleaners.find((item) => item._id === id)?.name || id)
                    .join(', ')
                }
              >
                {cleaners?.map((item) => (
                  <MenuItem key={item._id} value={item._id}>
                    <Checkbox checked={cleaner.indexOf(item._id) > -1} />
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 3 }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Refill Item <InfoTooltip title="Consumables (e.g. toiletries, coffee) the cleaner must restock at the selected properties." /></FormLabel>
              {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                multiple
                value={refillItem}
                onChange={(e) => setRefillItem(e.target.value)}
                renderValue={(selected) =>
                  selected
                    .map((id) => refill.find((item) => item._id === id)?.name || id)
                    .join(', ')
                }
              >
                {refill?.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    <Checkbox checked={refillItem.indexOf(user._id) > -1} />
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddAssignRefill;
